import React from "react";
import MobileTitleMaterialData from "./TitleMaterialData";

function MobileMaterialPro({ Data, getData, projectList, projectId ,Unit}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleMaterialData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId} Unit={Unit} />
          );
        })}
    </div>
  );
}

export default MobileMaterialPro;
